// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    import { CostReviewAttachmentProperties } from '../Classes/CostReviewAttachmentProperties';
import { UserProfile } from '../Classes/UserProfile';
export class Preferences {
  taxTypeID: number;
  layoutUserDefault: string;
  summaryViewConfiguration: string;
  recentFilesList: string;
  sensorID: number;
  valveTrimID: number;
  valvePortID: number;
  actuatorID: number;
  manufacturerInstalled: boolean;
  includeDampers: boolean;
  includeSmokeDetectors: boolean;
  includeTransformers: boolean;
  units: number;
  isMarkUpCalculations: boolean;
  grossMarginPercent: number;
  decimalPrecision: number | null;
  typicalOfSystemEfficiency: number;
  typicalOfAreaEfficiency: number;
  companyName: string;
  projectCountry: number | null;
  divisionName: string;
  salesOffice: number;
  segment: number | null;
  branchAddress1: string;
  branchAddress2: string;
  branchState: string;
  branchZipCode: string;
  branchContact: string;
  branchEmail: string;
  websiteAddress: string;
  defaultWorkingTab: number;
  laborRatesSync: number;
  materialCostsSync: number;
  customerDataSync: number;
  estimateSync: number;
  siteDistanceFromBranch: number;
  lodgingRate: number;
  parkingRate: number;
  tollsRate: number;
  estimatedTripsToSite: number;
  perDiemRate: number;
  milageRate: number;
  salesPersonEmail: string;
  cultureString: string;
  shippingHandlingRate: number | null;
  shippingHandlingRateForOutsideMat: number | null;
  shippingHandlingRateForMechanicalMat: number | null;
  shippingHandlingRateForElectricalMat: number | null;
  warrantyRate: number | null;
  warrantyRateForOutsideMat: number | null;
  warrantyRateForMechanicalMat: number | null;
  warrantyRateForElectricalMat: number | null;
  mechanicalRateProvidedByOther: boolean | null;
  electricalRateProvidedByOther: boolean | null;
  userType: number | null;
  showWarning: boolean | null;
  showCostColumn: boolean | null;
  showIO: boolean | null;
  showFLNCount: boolean | null;
  alnType: number | null;
  flnType: number | null;
  spareCapacity: number | null;
  hoa: boolean | null;
  showColorReport: boolean | null;
  showCOO: boolean | null;
  showPPM: boolean | null;
  salesPersonName: string;
  subSegmentId: number | null;
  showColorCartoons: boolean | null;
  dccSpareCapacityPercent: number | null;
  dccServerLicense: boolean | null;
  dccClientLicense: number;
  operatorDisplay: boolean | null;
  showTypical: boolean | null;
  enableCrossBusinessLibrary: boolean | null;
  showElectricalServicesWarning: boolean | null;
  projectUnits: number;
  showMonths: boolean | null;
  useAutoPM: boolean;
  engOffice: number | null;
  fsOffering: boolean;
  isSellPriceWithTax: boolean;
  attachmentPropertiesAutomation: CostReviewAttachmentProperties;
  attachmentPropertiesFire: CostReviewAttachmentProperties;
  attachmentPropertiesSecurity: CostReviewAttachmentProperties;
  attachmentPropertiesBps: CostReviewAttachmentProperties;
  userProfile: UserProfile;
  automationSubmittalId: string;
  fireSubmittalId: string;
  securitySubmittalId: string;
  electricalSubmittalId: string;
  attachmentPropertiesElectrical: CostReviewAttachmentProperties;
  mechanicalSubmittalId: string;
  attachmentPropertiesMechanical: CostReviewAttachmentProperties;
  addressableSpare: number | null;
  pointToPointCheckoutEfficiency: number | null;
  cEngAdjRate: number | null;
  cEngDiscntPercent: number | null;
  cEngDiscntType: number | null;
  ddsAdjRate: number | null;
  ddsDiscntPercent: number | null;
  ddsDiscntType: number | null;
  eEngAdjRate: number | null;
  eEngDiscntPercent: number | null;
  eEngDiscntType: number | null;
  elecAdjRate: number | null;
  elecDiscntPercent: number | null;
  elecDiscntType: number | null;
  electricalDiscntPercent: number | null;
  electricalDiscntType: number | null;
  engAdjRate: number | null;
  engDiscntPercent: number | null;
  engDiscntType: number | null;
  mostRecentlyOpenedEstimateListMaxItemCount: number | null;
  favoriteEstimateMaxItemCount: number | null;
  favoriteEstimate: string;
  grapAdjRate: number | null;
  grapDiscntPercent: number | null;
  grapDiscntType: number | null;
  isEngColumnsExpanded: boolean | null;
  isIOColumnsExpanded: boolean | null;
  lEngAdjRate: number | null;
  lEngDiscntPercent: number | null;
  lEngDiscntType: number | null;
  mechAdjRate: number | null;
  mechDiscntPercent: number | null;
  mechDiscntType: number | null;
  mechanicalDiscntPercent: number | null;
  mechanicalDiscntType: number | null;
  nEngAdjRate: number | null;
  nEngDiscntPercent: number | null;
  nEngDiscntType: number | null;
  networkApplianceSpare: number | null;
  outsideDiscntPercent: number | null;
  outsideDiscntType: number | null;
  overheadSubsPercent: number | null;
  overheadProjPercent: number | null;
  pmAdjRate: number | null;
  pmDiscntPercent: number | null;
  pmDiscntType: number | null;
  profitProjPercent: number | null;
  profitSubsPercent: number | null;
  progAdjRate: number | null;
  progDiscntPercent: number | null;
  progDiscntType: number | null;
  qEngAdjRate: number | null;
  qEngDiscntPercent: number | null;
  qEngDiscntType: number | null;
  romoteDisplaySpare: number | null;
  showAPNMaterialIndicator: boolean | null;
  showePartsMaterialIndicator: boolean | null;
  showExpanded: boolean | null;
  showGenericName: boolean | null;
  showRetiredGenericStdMaterialIndicator: boolean | null;
  showRetiredGenericUsrMaterialIndicator: boolean | null;
  showRPNMaterialIndicator: boolean | null;
  showRPNsTabAutomation: boolean | null;
  showRPNsTabElectrical: boolean | null;
  showRPNsTabFire: boolean | null;
  showRPNsTabMechanical: boolean | null;
  showRPNsTabSecurity: boolean | null;
  showStandardMaterialIndicator: boolean | null;
  showStandardServiceIndicator: boolean | null;
  showUPNMaterialIndicator: boolean | null;
  showUserDefinedMaterialIndicator: boolean | null;
  showUserDefinedServiceIndicator: boolean | null;
  siemensAtDiscntPercent: number | null;
  siemensAtDiscntType: number | null;
  siemensDiscntPercent: number | null;
  siemensDiscntType: number | null;
  specAdjRate: number | null;
  specDiscntPercent: number | null;
  specDiscntType: number | null;
  useProjectLeadRate: boolean | null;
}
